<h2 mat-dialog-title>{{data.title}}</h2>
<div mat-dialog-content>
  <img *ngIf="data.url" src="{{data.url}}" alt="Image fiche {{data.id}}" />
  <div *ngIf="data.type == 0 || !data.type " class="content" >{{data.content}}</div>
  <a *ngIf="data.type && data.type == 1"  target="new"  rel="noopener noreferrer" href="{{data.content}}">Cliquer ici pour suivre le lien</a>
</div>
<div mat-dialog-actions>
  <button mat-raised-button [mat-dialog-close] color="primary">FERMER</button>
</div>